import React from 'react';
import { GiftIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
import { Reassurance } from './Reassurance';
import { bonuses } from '../data/content';
export function BonusSection() {
  return <section className="w-full bg-canvas px-4 py-12 sm:px-6 sm:py-20" data-id="element-13" data-mp="22ell8se3fjke">
      <div className="mx-auto max-w-5xl" data-id="element-14" data-mp="1yeb5wp4evgsv">
        <div className="text-center" data-id="element-15" data-mp="1yfcpjhzhtbm7">
          <span className="inline-flex items-center gap-2 rounded-full bg-accent/10 px-3.5 py-1.5 font-display text-[0.7rem] font-extrabold uppercase tracking-wider text-accent-dark sm:px-4 sm:text-xs" data-id="element-16" data-mp="1yc6zo0j1i5pf">
            <GiftIcon className="h-4 w-4" aria-hidden="true" data-id="element-17" data-mp="1jgr2vnr2rvpc" />
            Explosión de valor
          </span>
          <h2 className="mt-3 font-display text-[1.6rem] font-extrabold leading-tight text-brand-deep sm:mt-4 sm:text-4xl" data-id="element-18" data-mp="1eqapg3n98a2z">
            5 Bonus Estratégicos incluidos hoy
          </h2>
        </div>

        <ul className="mt-8 grid gap-3 sm:mt-10 sm:grid-cols-2 sm:gap-4 lg:grid-cols-3" data-id="element-19" data-mp="mz4k98sofm6u">
          {bonuses.map(bonus => <li key={bonus.numero} className="flex h-full flex-col rounded-2xl border border-brand/10 bg-white p-4 text-left sm:p-5" data-id="element-20" data-mp="29r1rfa3g92tg">
              <div className="flex items-center justify-between gap-3" data-id="element-21" data-mp="2jhcu6tbed5yr">
                <span className="font-display text-[0.7rem] font-extrabold uppercase tracking-wider text-accent sm:text-xs" data-id="element-22" data-mp="2jk8takyze0os">
                  {bonus.numero}
                </span>
                <span className="flex shrink-0 items-center gap-1.5" data-id="element-23" data-mp="1qv1tlinsj51y">
                  <span className="font-display text-xs font-extrabold text-gray-400 line-through sm:text-sm" data-id="element-24" data-mp="1vtd7c4h7hzpg">
                    {bonus.valor}
                  </span>
                  <span className="rounded-full bg-accent px-2 py-0.5 font-display text-[0.65rem] font-extrabold uppercase tracking-wide text-white sm:text-[0.7rem]" data-id="element-25" data-mp="25r104ov94x4z">
                    Gratis
                  </span>
                </span>
              </div>
              <h3 className="mt-2 font-display text-base font-extrabold leading-snug text-brand-deep sm:text-lg" data-id="element-26" data-mp="3h7rbemej8f5g">
                {bonus.titulo}
              </h3>
              <p className="mt-1.5 text-[0.9rem] leading-relaxed text-gray-600 sm:text-sm" data-id="element-27" data-mp="1c396vxz2t2ia">
                {bonus.descripcion}
              </p>
            </li>)}
        </ul>

        <div className="mx-auto mt-8 max-w-md" data-id="element-28" data-mp="1m28hhm3ej87x">
          <CtaButton href="#precio" location="bonus" data-id="element-29" data-mp="1m0drvuh6qrxi">
            Quiero los bonus gratis
          </CtaButton>
          <Reassurance className="mt-3" items={['Incluidos sin costo extra', 'Acceso inmediato']} data-id="element-30" data-mp="yajftf4ox7eb" />
        </div>
      </div>
    </section>;
}